import { gql } from '@apollo/client'

export const SHOP_CUSTOMER_SPREEDLY_CARD_FRAGMENT = gql`
  fragment CustomerSpreedlyCard on ShopCustomerSpreedlyCard {
    id
    cardBrand
    cardholderName
    expMonth
    expYear
    last4
    primary
  }
`
